import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { useTranslation } from 'react-i18next';
import './style.css';

const OrdersAdmin = () => {
  const { t, i18n } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // Start at 1 for pagination
  const [totalPages, setTotalPages] = useState(1);
 const [statusFilter, setStatusFilter] = useState('');
const [dateFilter, setDateFilter] = useState(''); // values: '7', '15', '30'

const [searchID, setSearchID] = useState('');
 const ALL_STATUSES = [
       'en attente', 'livr�', 'annul�','attribu�','en transit'
    ];


  useEffect(() => {
    checkAdminStatus();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      fetchAllOrders(currentPage);
    }
  }, [isAdmin, currentPage]);

  const checkAdminStatus = () => {
    const isAdminFlag = localStorage.getItem('isAdmin') === '1';
    setIsAdmin(isAdminFlag);
    if (isAdminFlag) {
      fetchAllOrders(currentPage);
    }
  };

  const fetchAllOrders = async (page) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      const response = await axios.get(`https://elanciabioapi.com/api/admin/orders?page=${page}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setOrders(response.data.data);
        setPageCount(response.data.last_page);
        setTotalPages(response.data.last_page);
      } else {
        console.error('Failed to fetch orders:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const handleStatusChange = async (orderID, newStatus, paymentStatus) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      // Prevent marking as "livr�" if payment is "not pay�"
      if (newStatus === 'livr�' && paymentStatus === 'not pay�') {
        alert(t("Impossible_de_marquer_comme_livr�_si_non_pay�")); // Add this translation key in your i18n files
        return;
      }

      const response = await axios.put(
        `https://elanciabioapi.com/api/admin/orders/${orderID}/tracking`,
        { CurrentStatus: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        fetchAllOrders(currentPage);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };
const filteredOrders = orders.filter(order => {
  const matchStatus = statusFilter ? order.Status=== statusFilter : true;

  const matchDate = dateFilter
    ? (() => {
        const orderDate = new Date(order.created_at);
        const today = new Date();
        const pastDate = new Date();
        pastDate.setDate(today.getDate() - parseInt(dateFilter));
        return orderDate >= pastDate && orderDate <= today;
      })()
    : true;

  const searchTerm = searchID.trim();

 const matchSearchID = searchTerm
  ? order.OrderID.toString().includes(searchTerm) ||
    (order.supplier?.id && order.supplier.id.toString().includes(searchTerm)) ||
    (order.supplier?.custom_id && order.supplier.custom_id.toString().includes(searchTerm)) ||
    (order.customer_info.Name && order.customer_info.Name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (order.customer_info.Phone && order.customer_info.Phone.includes(searchTerm))
  : true;


  return matchStatus && matchDate && matchSearchID;
});
  // Helper to safely get translated text if field is an object with {ar, fr}
  const getLocalizedText = (field) => {
    if (!field) return '';
    if (typeof field === 'object') {
      return field[i18n.language] || field.fr || '';
    }
    return field;
  };

  if (!isAdmin) {
    return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
  }
const handleDeleteOrder = async (orderID, status) => {
  console.log("Order status:", status);

const normalizedStatus = status.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

  if (normalizedStatus !== 'en attente') {
  console.log("Cannot delete because status is:", normalizedStatus);
  return;
}

  const confirmDelete = window.confirm("étes-vous sur de vouloir supprimer cette commande ?");
  if (!confirmDelete) return;

  try {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    const response = await axios.delete(`https://elanciabioapi.com/api/admin/orders/${orderID}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      alert("Commande supprimée avec succés.");
fetchAllOrders(currentPage);
    } else {
      alert("échec de la suppression de la commande.");
    }
  } catch (error) {
    console.error("Erreur lors de la suppression :", error);
    alert("Une erreur s'est produite.");
  }
};
const getProductName = (productName) => {
  if (!productName) return '';
  try {
    // First, remove the extra quotes
    const firstParse = JSON.parse(productName);
    // Then parse the inner JSON
    const parsed = JSON.parse(firstParse);
    return parsed[i18n.language] || parsed.fr || '';
  } catch (error) {
    console.error('Error parsing product name:', productName, error);
    return productName; // fallback
  }
};


return (
  <AnimationRevealPage>
    <LightAdmin />

    <div className="d-flex">
      <section className="w-100 p-3">
        <div className="d-flex flex-wrap align-items-center justify-content-center mb-4 gap-4">

          <h1 className="text-dark display-5 w-100 text-center mb-3">
            {t('dashboard_orders_title')}
          </h1>

          <div className="d-flex flex-wrap align-items-center gap-3 justify-content-center">

            <div className="d-flex flex-column">
              <label className="form-label fw-bold text-dark mb-1 text-center">{t('filter_by_status')}</label>
              <select
                className="form-select border-dark shadow-sm"
                style={{ minWidth: '180px', maxWidth: '220px' }}
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">{t('all_statuses')}</option>
                <option value="en attente">{t('status_pending')}</option>
                <option value="en transit">{t('status_in_transit')}</option>
 <option value="reporte">{t('reporte')}</option>
  <option value="pas_de_reponse">{t('pas_de_reponse')}</option>

                <option value="livré">{t('status_delivered')}</option>
                <option value="annulé">{t('status_cancelled')}</option>
              </select>
            </div>

            <div className="d-flex flex-column">
              <label className="form-label fw-bold text-dark mb-1 text-center">{t('filter_by_date')}</label>
              <select
                className="form-select border-dark shadow-sm"
                style={{ minWidth: '180px', maxWidth: '220px' }}
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
              >
                <option value="">{t('all_dates')}</option>
                <option value="7">{t('last_7_days')}</option>
                <option value="15">{t('last_15_days')}</option>
                <option value="30">{t('last_30_days')}</option>
              </select>
            </div>

            <div className="d-flex flex-column">
              <label className="form-label fw-bold text-dark mb-1 text-center">{t('search_by_id')}</label>
              <input
                type="text"
                className="form-control border-dark shadow-sm"
                style={{ minWidth: '180px', maxWidth: '220px' }}
                placeholder={t('placeholder_order_id')}
                value={searchID}
                onChange={(e) => setSearchID(e.target.value)}
              />
            </div>

            <div className="d-flex align-items-end">
              <button
                className="btn"
                onClick={() => {
                  setStatusFilter('');
                  setDateFilter('');
                  setSearchID('');
                }}
                style={{
                  height: '38px',
                  backgroundColor: '#336734',
                  color: 'white',
                  borderRadius: '25px',
                  padding: '0 20px',
                  border: 'none',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(106, 151, 57, 0.6)',
                  transition: 'background-color 0.3s ease',
                  marginTop:'30px'
                }}
              >
                {t('reset_filters')}
              </button>
            </div>

          </div>
        </div>

        <hr className="my-4" />

        {/* Orders Table */}
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-primary">
              <tr>
                <th>{t('ID_de_commande')}</th>
                <th>{t('Fournisseur')}</th>
                <th>{t('Client')}</th>
                <th>{t('Statut_du_')}</th>
                <th>{t('Produits')}</th>
                <th>{t('Montant')}</th>
                <th>{t('Gain')}</th>
                <th>{t('created_at')}</th>
                <th>{t('statut')}</th>
                <th>{t('actions')}</th>


              </tr>
            </thead>
            <tbody>
              {filteredOrders.map((order) => {
                const normalizedStatus = order.status
                  ?.normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
                  .trim();

const isDeletable =
  normalizedStatus !== 'livre' &&
  normalizedStatus !== 'annule' &&
  normalizedStatus !== 'pas_de_reponse' &&
  normalizedStatus !== 'reporte';
                return (
                  <tr key={order.OrderID}>
                    <td>{order.OrderID}</td>
                    <td>
  {order.supplier?.name || t('Commandes_sans_code_promo')}<br />
  <small className="text-muted"> {order.supplier?.custom_id}</small>
</td>          
         <td>
  {order.customer_info.Name}&nbsp;<br/>
  <a href={`tel:${order.customer_info.Phone}`} style={{color: 'blue', textDecoration: 'underline'}}>
    {order.customer_info.Phone}<br/>
  </a>&nbsp;
  {order.customer_info.Address}
</td>                    <td>{order.status}</td>
                  <td>
  {order.order_items.map((item) => (
    <div key={item.OrderItemID}>
      {getProductName(item.product.Name)} <br/>(x{item.Quantity})
    </div>
  ))}
</td>                    <td>{order.payment.Amount} DH</td>
                    <td>{order.gain} DH</td>
<td>{new Date(order.created_at).toLocaleDateString('fr-FR')}</td>

               <td>
                                            <select
                                            style={{
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '8px 12px',
    backgroundColor: '#f9f9f9',
    fontSize: '14px',
    color: '#333',
    cursor: order.status === 'livr�' || order.status === 'annul�' ? 'not-allowed' : 'pointer',
    width: '160px',
  }}
                                                value={order.status}
                                                onChange={(e) => handleStatusChange(order.OrderID, e.target.value, order.payment.PaymentStatus)}
                                                className="form-control"
                                                disabled={order.status === 'livr�' || order.status === 'annul�'}
                                            >
                                                <option value="en attente">{t('en_attente')}</option>
                                                <option value="attribué">{t('attribué')}</option>
                                                <option value="en transit">{t('en_transit')}</option>
                                                <option value="livré">{t('livré')}</option>
                                                <option value="annulé">{t('annulé')}</option>
                                            </select>
                                        </td>
  <td>
  <button
    className="btn btn-sm"
      style={{ backgroundColor: 'red', color: 'white' }}
    disabled={!isDeletable}
    onClick={() => handleDeleteOrder(order.OrderID, order.status)}
    title="Supprimer"
  >
Supprimer
  </button>
</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-center">
          <nav>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  {t('Previous')}
                </button>
              </li>

              {[...Array(totalPages)].map((_, index) => (
                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                    {index + 1}
                  </button>
                </li>
              ))}

              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  {t('Next')}
                </button>
              </li>
            </ul>
          </nav>
        </div>

        {/* Admin Instructions */}
        <div className="alert alert-info mt-4" style={{ backgroundColor: '#f3bbc6' }}>
          <h5>Instructions pour l'admin :</h5>
          <ul>
            <li>{t('instruction_livre_si_paye')}</li>
            <li>{t('instruction_modifier_desactive')}</li>
          </ul>
        </div>
      </section>
    </div>
    <Footer />
  </AnimationRevealPage>
  );
};

export default OrdersAdmin;
